export const NoResultFound = () => {
  return (
    <div className="no-results-found text-center w-100 py-5 px-3" style={{ margin: "auto" }}>
      <i className="fa-solid fa-magnifying-glass mb-3" style={{ fontSize: "3rem", color: "#adb5bd" }} />
      <div style={{ fontSize: "1.1rem", color: "#6c757d" }}>No Results Found</div>
    </div>
  );
};
